import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import SliderImage from '../slideImage/SliderImage'
import './slide.scss'
import SliderVideo, { OVERLAY_CLASS } from '../slideVideo/SliderVideo'

export default class Slide extends Component {
  static propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    video: PropTypes.string,
    active: PropTypes.bool,
    alt: PropTypes.string,
    imgTitle: PropTypes.string,
    mobile: PropTypes.arrayOf(
      PropTypes.shape({
        width: PropTypes.string.isRequired,
        src: PropTypes.string.isRequired,
      }),
    ),
  }

  static defaultProps = {
    image: '',
    video: '',
    title: '',
    active: false,
    alt: '',
    imgTitle: '',
  }

  getSlide = () => {
    const {
      image,
      mobile,
      video,
      title,
      alt,
      imgTitle,
      width,
      height,
    } = this.props
    if (typeof image && video) {
      return <SliderVideo video={video} title={title} />
    }
    if (image) {
      return (
        <SliderImage
          src={image}
          mobile={mobile}
          alt={alt}
          title={imgTitle}
          width={width}
          height={height}
        />
      )
    }
    return null
  }

  render() {
    const { image, video, className } = this.props
    const setOverlay = typeof image && video
    return (
      <div
        role="presentation"
        className={cn('slide', className)}
      >
        <div className={cn('slide-content', setOverlay && OVERLAY_CLASS)}>
          {this.getSlide()}
        </div>
      </div>
    )
  }
}
